let defOpt = {
  quality: 1
};

export default class ImageFileHelper {
  constructor(option) {
    let opt = Object.assign({}, defOpt, option);

    let canvas = document.createElement('canvas');
    canvas.style.display = 'none';
    document.querySelector('body').appendChild(canvas);

    this._canvas = canvas;
    this._context = canvas.getContext('2d');
    this._opt = opt;
  }

  async getThumbDataUrl(imgFile, option) {
    let opt = Object.assign({}, this._opt, option);
    let mimeType = opt.mimeType || imgFile.type;

    let canvas = await this._renderThumbImage(imgFile, opt.maxWidth, opt.maxHeight);
    return canvas.toDataURL(mimeType, opt.quality);
  }

  async getThumbBlob(imgFile, option) {
    let opt = Object.assign({}, this._opt, option);
    let mimeType = opt.mimeType || imgFile.type;

    let canvas = await this._renderThumbImage(imgFile, opt.maxWidth, opt.maxHeight);
    return new Promise((resolve, reject) => {
      try {
        canvas.toBlob(blob => resolve(blob), mimeType, opt.quality);
      } catch (e) {
        console.error('[ImageFileHelper] ' + e.message);
        reject(e);
      }
    });
  }

  getDataUrl(blob) {
    return new Promise((resolve, reject) => {
      try {
        // read file, and then pass it to image object.
        let reader = new FileReader();
        // when file load event occur, set image src to trigger image load event
        reader.addEventListener('load', () => {
          resolve(reader.result);
        });
        reader.readAsDataURL(blob);
      } catch (e) {
        console.error('[ImageFileHelper] ' + e.message);
        reject(e);
      }
    });
  }

  destroy() {
    this._canvas.remove();
  }

  _renderThumbImage(imgFile, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      if (!maxWidth && !maxHeight) {
        let err = new Error('[ImageFileHelper] At least one of size(widht or hieght) is required.');
        reject(err);
      }
      // object of original image
      let imageObj = new Image();
      // create thumb on canvas when original image was loaded
      // and then resolve it as thumb's data URI.
      imageObj.addEventListener('load', () => {
        // v1 - release image object url
        URL.revokeObjectURL(imageObjUrl);

        try {
          let thumbSize = this._getThumbSize(imageObj, maxWidth, maxHeight);
          this._canvas.width = thumbSize.width;
          this._canvas.height = thumbSize.height;
          // draw thumb
          this._context.drawImage(imageObj, 0, 0, thumbSize.width, thumbSize.height);
          resolve(this._canvas);
        } catch (e) {
          reject(e);
        }
      });

      // v1 - using URL.createObjectURL
      let imageObjUrl = URL.createObjectURL(imgFile);
      imageObj.src = imageObjUrl;

      // v2 - using FileReader
      // try {
      //   // read file, and then pass it to image object.
      //   let reader = new FileReader();
      //   // when file load event occur, set image src to trigger image load event
      //   reader.addEventListener('load', () => {
      //     imageObj.src = reader.result;
      //   });
      //   reader.readAsDataURL(imgFile);
      // } catch (e) {
      //   reject(e);
      // }
    });
  }

  _getThumbSize(img, maxWidth, maxHeight) {
    let size = {};

    if (maxWidth && maxWidth) {
      let wRatio = maxWidth / img.width;
      let hRatio = maxHeight / img.height;

      let wRatioWidth = maxWidth;
      let wRatioHeight = Math.round(img.height * wRatio);

      let hRatioWidth = Math.round(img.width * hRatio);
      let hRatioHeight = maxHeight;

      if (wRatioHeight > maxHeight) {
        size.width = hRatioWidth;
        size.height = hRatioHeight;
      } else {
        size.width = wRatioWidth;
        size.height = wRatioHeight;
      }

    } else if (maxWidth && !maxHeight) {
      let ratio = maxWidth / img.width;
      size.width = maxWidth;
      size.height = Math.round(img.height * ratio);
    } else if (!maxWidth && maxHeight) {
      let ratio = maxHeight / img.height;
      size.width = Math.round(img.width * ratio);
      size.height = maxHeight;
    } else {
      size.width = maxWidth;
      size.height = maxHeight;
    }

    // if thumb size is greather than original image, set back to original size.
    if (size.width > img.width && size.height > img.height) {
      size.width = img.width;
      size.height = img.height;
    }

    return size;
  }
}

